import { render } from "./Reach.vue?vue&type=template&id=87c4c178"
import script from "./Reach.vue?vue&type=script&lang=js"
export * from "./Reach.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__